import * as React from 'react';

import { style } from 'typestyle';
import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { DraftTags } from '../../../drafts/components/DraftTags';
import { DraftTagsParentType } from '../../../drafts/types/DraftsTypes';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { FlowBaseInfo } from '../../../ts/models/FlowInfo';
import { ContentDraftStatus } from '../../../ts/ServerApi/types/ContentDraft';
import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';
import { ServiceLocator } from '../../ServiceLocator';
import { doesTooltipNotHaveOwnerToDisplay } from '../Tooltips/Elements/Tooltip';
import { FlowTooltip } from '../Tooltips/FlowTooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';

const draftStatusWrapper = style({
  display: 'flex',
  marginBottom: CommonStyles.Sizes.SmallSpace,
});

export const FlowDefaultImageUrl = imgPath('spaces_masthead_flow.svg');

export class FlowCard extends ContentCard {

  private renderDraftStatus(flow: FlowBaseInfo) {
    return (
      <div className={draftStatusWrapper}>
        <DraftTags
          draftStatus={flow.draftStatus}
          parentType={DraftTagsParentType.card}
          explorableItemType={'flow'}
        />
      </div>
    );
  }
  public render() {
    const flow = this.props.content as FlowBaseInfo;
    const isUnpublishedFlowDraft = FeatureFlags.flowDraftsEnabled && flow.draftStatus === ContentDraftStatus.unpublished;
    const shouldShowFavoritesButton: boolean = this.showFavoritesStar() && !isUnpublishedFlowDraft;
    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(flow);

    let navigateUrl = isUnpublishedFlowDraft ?
      this.props.urls.flowEditorDraftUrl(flow.draftLuid) :
      getContentUrlForItem(this.props.content, this.props.urls);

    if (isUnpublishedFlowDraft) {
      const server = getSessionManagementServiceInstance();
      if (flow.owner.id !== server.sessionUserId()) {
        navigateUrl = undefined;
      }
    }

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          title={Messages.flowTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <Thumbnail
            defaultImageUrl={FlowDefaultImageUrl}
            thumbnailImageUrl={this.props.content.thumbnailUrl}
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={navigateUrl}
            useBase64EncodedImage={true}
            allowDragAndDrop={this.props.allowDragAndDrop}
            openLinkInNewTab={isUnpublishedFlowDraft}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          {shouldShowFavoritesButton && <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'flow' })}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'flow' })}
            />
          </span>}
          { this.renderActionsMenu() }
        </div>
        {FeatureFlags.flowDraftsEnabled && this.renderDraftStatus(flow)}
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return (
      <FlowTooltip
        content={this.props.content}
        urls={this.props.urls}
        inProjectSpace={this.props.inProjectSpace}
      />
    );
  }
}
